module.exports = __webpack_public_path__ + "img/animals_04_H.dd98730f.jpg";